module.exports = __webpack_public_path__ + "static/media/version_control_dark.8277e6c0.svg";